//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import uiBottom from '@/component/uiBottom'
import uiRadio from '@/component/uiRadio'
import uiChecker from '@/component/uiChecker'
import { getUserInfo, isApp } from '@/util/const'
import { setAuthorization, getLang } from '../../axios/userInfo'

export default {
  components: {
    uiRadio,
    uiBottom,
    uiChecker
  },
  data () {
    return {
      loading: false,
      apply: {
        name: '',
        phone: '',
        email: '',
        withFriend: '',
        concertId: 1,
        customerId: '',
        msisdn: ''
      },
      textReg: [{
        rule: /^\s*$/,
        tips: this.$t('question.tips')
      }],
      emailReg: [{
        rule: /^\s*$/,
        tips: this.$t('question.tips')
      }, {
        flag: true,
        rule: /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/,
        tips: this.$t('question.question20')
      }],
      showDialog1: false,
      showDialog2: false,
      read: false
    }
  },
  created () {
    window.getUserInfo = (obj) => {
      console.log(obj.boss)
      if (obj && obj.boss) {
        setAuthorization(obj.authorization)
        this.apply.name = obj.boss.user.postpaid.lastName + ' ' + obj.boss.user.postpaid.firstName
        this.apply.customerId = obj.boss.user.postpaid.customerId
        this.apply.msisdn = obj.boss.user.postpaid.msisdn
        this.apply.phone = obj.user.phone
        this.apply.email = obj.user.email
      }
    }
    if (isApp()) {
      getUserInfo({ callbackName: 'getUserInfo', needLogin: true })
    } else {
      setAuthorization('20a1429c-13f5-4f0b-9895-fdf881351d76')
      this.apply.name = 'Peter Pan'
      this.apply.phone = '92046747'
      this.apply.email = 'mchaung@hk.chinamobile.com'
    }
  },
  watch: {
    'apply.withFriend': function (v) {
      let len = 0
      for (let i = 0; i < v.length; i++) {
        if (v.charCodeAt(i) > 127 || v.charCodeAt(i) == 94) {
          len += 2
        } else {
          len++
        }
        if (len > 400) {
          this.apply.withFriend = this.apply.withFriend.slice(0, i)
          break
        }
      }
    }
  },
  methods: {
    jump () {
      if (this.$valid()) {
        this.loading = true
        this.$http.post(`/v1/api/user/hanaConcert/signUp`, { body: this.apply }).then(res => {
          this.loading = false
          if (res.data.body.result === 0) {
            this.$router.replace({ path: '/applySuccess' })
          } else {
            this.$router.replace({ path: '/invalidPage' })
          }
        })
      }
    },
    details (type) {
      this['showDialog' + type] = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/concert/applyForm.vue